import React, { useMemo } from "react"
import { X, CalendarDays } from "lucide-react"
import { useTranslation } from "react-i18next"
import CardWrapper from "./CardWrapper"
import { formatDateArray } from "../../../utils/date/format"
import CalendarModal from "./CalendarModal"
import { CALENDAR_FIX_MODE } from "../../../utils/variables/calendar"
import CurrencySelector from "../../CurrencySelector"

const DateCard = ({
  isDeparture = false,
  dates,
  onDatesChange,
  handleModal,
  isOpenCalendar,
  availableDepart,
  availableRetur,
  departPriceData,
  returPriceData,
  onCalendarMonthChange,
  // только для isDeparture=false:
  currency,
  currencies,
  onCurrencyChange,
}) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language

  const activeArray = isDeparture ? (dates?.depart ?? []) : (dates?.return ?? [])
  const hasValue = activeArray.some(Boolean)

  const displayDate = useMemo(() => formatDateArray(activeArray, locale), [activeArray, locale])

  const label = isDeparture ? t("airform.departure_date") : t("airform.departure_date_back")

  const currencySymbol = currencies?.find((c) => c.code === currency)?.symbol ?? "€"

  const handleClear = (e) => {
    e.stopPropagation()
    onDatesChange?.(
      isDeparture ? { from: [], to: dates?.return ?? [] } : { from: dates?.depart ?? [], to: [] }
    )
  }

  return (
    <>
      <CardWrapper>
        <div
          className="flex items-center overflow-visible h-[45px] gap-4 relative cursor-pointer"
          onClick={handleModal}
        >
          <CalendarDays className="w-5 h-5 text-app-content-subtle flex shrink-0" />
          <div className="flex flex-col h-full text-sm truncate">
            <span className="text-app-content-subtle">{label}</span>
            <span className="text-text-main">{displayDate || t("admin.select_date")}</span>
          </div>
        </div>

        {hasValue && (
          <button
            onClick={handleClear}
            className="absolute top-1/2 -translate-y-1/2 -right-3 w-6 h-6 flex items-center justify-center rounded-full bg-bg-secondary hover:bg-app-content-faint/20 transition-colors cursor-pointer"
          >
            <X className="w-4 h-4 text-app-content-subtle" />
          </button>
        )}

        {!isDeparture && currencies && (
          <CurrencySelector
            currencies={currencies}
            currency={currency}
            onChange={onCurrencyChange}
            additionalClasses="absolute hidden sm:block"
          />
        )}

        <CalendarModal
          showModal={isOpenCalendar}
          onClose={handleModal}
          isDeparture={isDeparture}
          dates={dates}
          onDatesChange={onDatesChange}
          mode={CALENDAR_FIX_MODE}
          className={
            isDeparture
              ? "md:left-0"
              : "md:right-[-240px] lg:right-[-176px] xl:right-[-40px] 2xl:right-0"
          }
          availableDepart={availableDepart}
          availableRetur={availableRetur}
          departPriceData={departPriceData}
          returPriceData={returPriceData}
          onCalendarMonthChange={onCalendarMonthChange}
          currencySymbol={currencySymbol}
        />
      </CardWrapper>
    </>
  )
}

export default DateCard
